export * from "app/model";

export interface ManagementOfChange {
    id: string;
    wellStringId?: string;
    platformShortName?: string;
    platformLongName?: string;
    fieldShortName?: string;
    fieldLongName?: string;
    wellShortName?: string;
    wellLongName?: string;
    stringShortName?: string;
    stringLongName?: string;
    title?: string;
    refNo?: string; 
    extensionNo?: string;
    startDate?: string; 
    endDate?: string; 
    keyIssues?: string;
    status?: string; 
    approvedStatus?: string; 
    stage?: string; 
    closedDate?: string; 
    requestedBy?: string;
}

export interface ManagementOfChangeRecords {
    records: ManagementOfChange[];
}

export enum MocStatus {
    ACTIVE = 'Active',
    APPROVALPROCESS = 'Approval Process',
    CANCELLED = 'Cancelled',
    CLOSED = 'Closed',
    CLOSEOUT = 'Close-Out',
    EXTENSIONAPPROVALPROCESS = 'Extension Approval Process',
    REJECTED = 'Rejected',
}

export enum MocApprovalStatus {
    APPROVED = 'Approved',
    PENDING = 'Pending Approval',
    REJECTED = 'Rejected',
}